<style scoped lang="scss">
.muted {
    color: #999;
}
.light-green {
  background-color: #bfffbf !important;
}
.light-red {
  background-color: #fdaaaa !important;
}

</style>



<template>

    <div class="step-wrapper" v-if="application && confirmation">
        <div class="uk-grid">
            <div class="uk-align-center uk-width-small-1-1 uk-width-medium-4-5" v-if="application.program.settings['landlord-video-url']">
              <p align="center" class="uk-margin-top uk-margin-bottom">
                <iframe width="560" height="315" :src="application.program.settings['landlord-video-url']" title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
              </p>
              <p align="center">A Walkthrough of Approving Assistance</p>
            </div>
            <div class="uk-align-center uk-width-small-1-1 uk-width-medium-4-5">

                <div class="uk-grid renter-info">
                    <div class="uk-width-1-1 uk-margin-large-bottom">
                        <h1>Do You Approve?</h1>
                      <p v-if="env.LANG_KEY == 'kera_'">
                        Your participation in this program will help ensure {{ applicant.first_name }} does not
                        become a further victim of COVID 19.  This aid must reinstate them to avoid eviction.  Your
                        commitment by accepting this aid means any current eviction process will be cancelled, and no new
                        eviction process will be pursued for the months for which KERA funds are received.
                      </p>
                      <p v-else-if="env.LANG_KEY == 'mn_'">Your participation in this program will help <b>{{ applicant.first_name }}</b> with their housing stability.</p>
                      <p v-else-if="env.LANG_KEY == 'orera_'">Your participation in this program will help <b>{{ applicant.first_name }}</b> with their housing stability. This aid must reinstate them to avoid eviction. Your commitment by accepting this aid means any current eviction process will be cancelled.</p>
                      <p v-else>
                        Your participation in this program will help ensure {{ applicant.first_name }} does not
                        become a further victim of COVID 19. This aid must reinstate them to avoid eviction. Your
                        commitment by accepting this aid means any current eviction process will be cancelled, and no
                        new eviction process can start from 30 days of receipt of the funds.
                      </p>


                    </div>
                    <hr class="uk-width-1-1">
                    <div class="uk-width-1-1 uk-flex uk-flex-space-between">
                        <div>
                            <h2 v-if="this.confirmation && this.confirmation.user && this.confirmation.user.confidential_address_program >= applicant.confidential_address_program">{{ applicant.first_name }} {{ applicant.last_name }}</h2>
                            <h2 v-else>Applicant's Name is Confidential</h2>
                        </div>

                        <div>
                            <h2>{{ applicant.primary_contact.formatted_number }}</h2>
                        </div>
                    </div>

                    <div class="uk-width-1-2 uk-text-left">
                        <h3>
                            {{ applicant.property_address.line_1 }}
                            {{ applicant.property_address.line_2 }}
                        </h3>
                    </div>
                    <div class="uk-width-1-2 uk-text-right">
                        <h3>
                            {{ applicant.property_address.city }}
                        </h3>
                    </div>

                    <div class="uk-width-1-1 uk-margin-bottom">
                        <hr>
                    </div>
                </div>

                <div class="uk-grid total-requested">

                    <div class="uk-width-1-1 uk-margin-bottom">
                        <div class="uk-align-left">
                            <h2>Total Requested Aid:</h2>
                        </div>
                        <div class="uk-align-right">
                            <h2>{{ getTotalRentRequested | formatMoney }}</h2>
                        </div>
                    </div>
                </div>


              <div class="uk-grid selection-buttons">
                <div :class="cellWidth" class="uk-width-small-1-1 uk-margin-large-bottom uk-text-left-medium">
                  <input id="confirmation_approval" type="radio" :disabled="isLocked"  v-model="confirmation.approval" value="approved">
                  <label for="confirmation_approval" class="use-hand-cursor" style="font-size: 1.2em;">I Approve {{ getTotalRentRequested | formatMoney }}</label>


                </div>
                <div :class="cellWidth" class="uk-width-small-1-1 uk-margin-large-bottom uk-text-left-small">
                  <validated-section field="corrected" :errors="errors">
                    <input id="confirmation_correction" type="radio" :disabled="isLocked" v-model="confirmation.approval" value="corrected">
                    <label for="confirmation_correction" class="use-hand-cursor" style="font-size: 1.2em;">This Amount Needs Correction</label>
                  </validated-section>
                </div>

                <div :class="cellWidth" class="uk-width-small-1-1 uk-margin-large-bottom uk-text-right-medium">
                  <input id="confirmation_decline" type="radio" :disabled="isLocked" v-model="confirmation.approval" value="declined">
                  <label for="confirmation_decline" class="use-hand-cursor" style="font-size: 1.2em;">I Do Not Wish To Participate</label>
                </div>

                <div :class="cellWidth" v-if="programSettings['show-landlord-not-mine']" class="uk-width-small-1-1 uk-margin-large-bottom uk-text-right-medium">
                  <input id="confirmation_notmine" type="radio" :disabled="isLocked" v-model="confirmation.approval" value="notmine">
                  <label for="confirmation_notmine" class="use-hand-cursor" style="font-size: 1.2em;">Not My Tenant</label>
                </div>
              </div>

                <div v-if="isEditMode" class="uk-grid total-requested" >

                    <div class="uk-width-1-1 uk-margin-bottom">
                        <div class="uk-align-left">
                          <validated-section :errors="errors" field="unit_ledger_entries.duplicated">
                              <h2>Total Updated Aid:</h2>
                          </validated-section>
                        </div>
                        <div class="uk-align-right">
                            <h2>{{ updatedAmount | formatMoney }}</h2>
                        </div>
                    </div>
                </div>
                <div v-if="confirmation.approval !== 'declined' " class="uk-grid request-details uk-margin-large-bottom">
                    <div class="uk-overflow-container uk-hidden-small uk-width-medium-1-1">
                        <table class="uk-width-1-1 uk-table uk-table-divider uk-table-striped">
                            <thead>
                            <tr>
                                <th class="">Month</th>
                                <th class="">Rent Due</th>
                                <th class="">Rent Paid</th>
                                <th class="" v-if="application.program.settings['uses-ledger-entry-fees']">Fees Due</th>
                                <th class="" v-if="application.program.settings['uses-duplicative-assistance']">Other Assistance Amount</th>
                                <th class="uk-text-right">Total Requested</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(values, month) in monthInputs" v-if="isEditMode || getRentMetaForDate(month)" :class="getClassForMonth(month)">
                                <td>
                                    <input
                                        v-if="showCheckBox(month)"
                                        v-model="checkedMonths"
                                        type="checkbox"
                                        :ref="'input_'+month"
                                        :aria-label="month"
                                        :disabled="getValueForMonth(month, 'has_payment') !== 0 || isLocked"
                                        :value="month"
                                        @change="onMonthCheckedChange(month, $event)"
                                    />
                                    {{ month | moment('MMM YYYY') }}
                                    <div v-if="alreadyHasAssistance(month)" class="muted" style="font-size: 0.8em;">
                                      <span v-if="alreadyHasAssistance(month).household_application_id">
                                        ALREADY REQUESTED ON APP # {{ alreadyHasAssistance(month).household_application_id }}
                                      </span>
                                      <span v-else>
                                        MONTH HAS ALREADY BEEN SUBMITTED FOR PAYMENT
                                      </span>
                                    </div>
                                </td>
                                <td>
                                    <div v-if="canEditMonth(month)">
                                        <vue-numeric :disabled="alreadyHasAssistance(month) || isLocked" :precision="2" currency="$" v-model="monthInputs[month].due"></vue-numeric>
                                    </div>
                                    <div :class="{muted: canEditMonth(month)}">
                                        <span v-if="canEditMonth(month)">Tenant Entered:</span>
                                        {{ getTenantMetaForDate(month).due | formatMoney }}
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <div v-if="canEditMonth(month)">
                                            <vue-numeric :disabled="alreadyHasAssistance(month) || isLocked" :precision="2" currency="$" v-model="monthInputs[month].paid"></vue-numeric>
                                        </div>
                                        <div :class="{muted: canEditMonth(month)}">
                                            <span v-if="canEditMonth(month)">Tenant Entered:</span>
                                            {{ getTenantMetaForDate(month).paid | formatMoney }}
                                        </div>
                                    </div>
                                </td>
                                <td v-if="application.program.settings['uses-ledger-entry-fees']">
                                    <div>
                                        <div v-if="canEditMonth(month)">
                                            <vue-numeric :disabled="alreadyHasAssistance(month) || isLocked" :precision="2" currency="$" v-model="monthInputs[month].fees" @change.native="checkMaxFees(month)"></vue-numeric>
                                        </div>
                                        <div :class="{muted: canEditMonth(month)}">
                                            <span v-if="canEditMonth(month)">Tenant Entered:</span>
                                            {{ getTenantMetaForDate(month).fees | formatMoney }}
                                        </div>
                                    </div>
                                </td>
                                <td v-if="application.program.settings['uses-duplicative-assistance']">
                                    <div class="uk-margin-bottom"
                                        v-for="(program, i) in values.alternative_funding_programs"
                                        :key="i"
                                    >
                                        <div v-if="canEditMonth(month)">
                                            <currency-input :disabled="alreadyHasAssistance(month) || isLocked" :currency="{ prefix: '$ '}" v-model="program.pivot.amount"/>
                                            <select placeholder="Select Source"
                                                    v-model="program.pivot.alternative_funding_program_id"
                                                    class="uk-input uk-select" style="width: 175px;">
                                                <option :value="null">Choose a Source...</option>
                                                <option
                                                    v-for="(_program, i1) in alternativeFundingPrograms"
                                                    :key="i1"
                                                    :value="_program.id"
                                                >
                                                    {{ _program.name }}
                                                </option>
                                            </select>
                                            <a href="javascript:;" class="uk-text-danger"
                                            v-if="canEditMonth(month)"
                                            @click="values.alternative_funding_programs.splice(i, 1)"><i
                                                    class="a-trash-2"></i></a>
                                        </div>
                                        <div :class="{muted: canEditMonth(month)}">
                                            <div v-if="getUniteLedgerDataForDate(month).alternative_funding_programs.hasOwnProperty(i)">
                                                <span v-if="canEditMonth(month)">Tenant Entered:</span>
                                                <span>{{ getUniteLedgerDataForDate(month).alternative_funding_programs[i].pivot.amount | formatMoney }} - {{ getAlernativeFundProgramName(getUniteLedgerDataForDate(month).alternative_funding_programs[i].pivot.alternative_funding_program_id) }} </span>
                                            </div>
                                        </div>
                                    </div>
                                    <a href="javascript:;"
                                    v-if="canEditMonth(month)"
                                    @click="addAssistance(values.alternative_funding_programs)"><i
                                            class="a-circle-plus"></i> Report Other Funding Received</a>
                                </td>
                                <td class="uk-text-right">
                                    <div v-if="canEditMonth(month)">
                                        {{ getTotalRequestByMonth(month) | formatMoney }}
                                    </div>
                                    <div :class="{muted: canEditMonth(month)}">
                                        <span v-if="canEditMonth(month)">Tenant Entered:</span>
                                        {{ getTotalRequestByMonth(month, 'tenant') | formatMoney }}
                                    </div>

                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="uk-grid uk-width-small-1-1 uk-hidden-medium uk-hidden-large uk-form uk-form-horizontal uk-form-stacked">
                        <div :class="getClassForMonth(month)" class="uk-width-1-1 uk-grid" v-for="(values, month) in monthInputs">
                            <div class="uk-width-1-1">
                                <h4>
                                    <input
                                        v-if="showCheckBox(month)"
                                        v-model="checkedMonths"
                                        type="checkbox"
                                        :ref="'input_'+month"
                                        :aria-label="month"
                                        :disabled="getValueForMonth(month, 'has_payment') !== 0"
                                        :value="month"
                                        @change="onMonthCheckedChange(month, $event)"
                                    />
                                    {{ month | moment('MMM YYYY') }}
                                    <div v-if="alreadyHasAssistance(month)" class="muted" style="font-size: 0.8em;">
                                        <span v-if="alreadyHasAssistance(month).household_application_id">
                                        ALREADY REQUESTED ON APP # {{ alreadyHasAssistance(month).household_application_id }}
                                        </span>
                                        <span v-else>
                                        MONTH HAS ALREADY BEEN SUBMITTED FOR PAYMENT
                                        </span>
                                    </div>
                                </h4>

                            </div>
                            <div class="uk-width-1-1 uk-margin-top uk-margin-large-bottom">
                                <div class="uk-form-row">
                                    <label class="uk-form-label" for="">{{ month | moment('MMM YYYY') }} Due</label>
                                    <div v-if="canEditMonth(month)">
                                        <vue-numeric :disabled="alreadyHasAssistance(month) || isLocked" :precision="2" currency="$" v-model="monthInputs[month].due"></vue-numeric>
                                    </div>
                                    <div :class="{muted: canEditMonth(month)}">
                                        <span v-if="canEditMonth(month)">Tenant Entered:</span>
                                        {{ getTenantMetaForDate(month).due | formatMoney }}
                                    </div>
                                </div>
                                <div class="uk-form-row">
                                    <label class="uk-form-label" for="">{{ month | moment('MMM YYYY') }} Rent Paid</label>
                                    <div v-if="canEditMonth(month)">
                                        <vue-numeric :disabled="alreadyHasAssistance(month) || isLocked" :precision="2" currency="$" v-model="monthInputs[month].paid"></vue-numeric>
                                    </div>
                                    <div :class="{muted: canEditMonth(month)}">
                                        <span v-if="canEditMonth(month)">Tenant Entered:</span>
                                        {{ getTenantMetaForDate(month).paid | formatMoney }}
                                    </div>
                                </div>
                                <div class="uk-form-row" v-if="application.program.settings['uses-ledger-entry-fees']">
                                    <label class="uk-form-label" for="">{{ month | moment('MMM YYYY') }} Fees Due</label>
                                    <div v-if="canEditMonth(month)">
                                        <vue-numeric :disabled="alreadyHasAssistance(month) || isLocked" :precision="2" currency="$" v-model="monthInputs[month].fees"></vue-numeric>
                                    </div>
                                    <div :class="{muted: canEditMonth(month)}">
                                        <span v-if="canEditMonth(month)">Tenant Entered:</span>
                                        {{ getTenantMetaForDate(month).fees | formatMoney }}
                                    </div>
                                </div>
                                <div class="uk-form-row">
                                    <label class="uk-form-label" for="">{{ month | moment('MMM YYYY') }} Amount Requested</label>
                                    <div v-if="canEditMonth(month)">
                                        {{ getTotalRequestByMonth(month) | formatMoney }}
                                    </div>
                                    <div :class="{muted: canEditMonth(month)}">
                                        <span v-if="canEditMonth(month)">Tenant Entered:</span>
                                        {{ getTotalRequestByMonth(month, 'tenant') | formatMoney }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="confirmation.approval == 'declined'">
                    <h5 for="confirmation_note">Leave Feedback</h5>
                    <textarea
                        :disabled="isLocked"
                        style="min-height: 100px;" rows="8"
                        class="uk-width-1-1 uk-form-large uk-input uk-resize-vertical"
                        name="confirmation_note"
                        v-model="confirmation.notes"
                        placeholder="Leave feedback here."
                    ></textarea>
                </div>
                <div v-else>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import ValidatedSection from "../../../components/Common/ValidatedSection";

    export default {
        name: "Step1",
        components: {ValidatedSection},
        data() {
            return {
                errors: {},
                monthInputs: {},
                checkedMonths: [],
                months: [],
            }
        },
        computed: {
            cellWidth() {
                return this.programSettings['show-landlord-not-mine'] ? 'uk-width-medium-1-4' : 'uk-width-medium-1-3';
            },
            isEditMode() {
                return this.confirmation.approval === 'corrected';
            },

            isLocked() {
                return this.confirmation && this.confirmation.is_locked
            },

            getTotalRentRequested() {
                let total = 0;
                let metaData = this.application.requested_rent_meta
                if (this.isLocked)
                {
                    if (this.confirmation.signed_at_meta && this.confirmation.signed_at_meta.requested_data && this.confirmation.signed_at_meta.requested_data.unit_ledger_entries)
                        metaData = this.confirmation.signed_at_meta.requested_data.unit_ledger_entries.filter(item => item.unit_ledger_entry_type_id === 1)
                }
                _.each(metaData, row => {
                    const alternativeFundingProgramRecord = JSON.parse(JSON.stringify(this.getUniteLedgerDataForDate(row.date)));
                    const alternativeFundingProgram = alternativeFundingProgramRecord.alternative_funding_programs ? alternativeFundingProgramRecord.alternative_funding_programs: []
                    let totalAdditionalFund = alternativeFundingProgram.reduce((sum, item) => sum + parseFloat(item.pivot.amount), 0)
                    total += parseFloat(row.due) + parseFloat(row.fees) - parseFloat(row.paid) - totalAdditionalFund;
                })
                return total;
            },

            updatedAmount() {
                let total = 0;
                _.each(this.monthInputs, value => {
                    if (value.own_ule === false)
                        return
                    let alternativeFundingProgram = value.alternative_funding_programs ? value.alternative_funding_programs : []
                    let totalAdditionalFund = alternativeFundingProgram.reduce((sum, item) => sum + parseFloat(item.pivot.amount), 0)
                    let toAdd = value.fees + value.due - value.paid - totalAdditionalFund;
                    total += toAdd;
                })
                return total;
            },

            isHomeless() {
                return this.application.is_homeless && this.programSettings['uses-homeless-application']
            },

            rentType () {
                return this.application.program.unit_ledger_entry_types.find(item => item.id = 1)
            },

            entries() {
                let ules = this.unitLedgerEntries,
                    sharedUles = this.sharedUnitLedgerEntries

                if (this.isLocked)
                {
                    if (this.confirmation.signed_at_meta && this.confirmation.signed_at_meta.requested_data && this.confirmation.signed_at_meta.requested_data.unit_ledger_entries)
                        ules = this.confirmation.signed_at_meta.requested_data.unit_ledger_entries

                    if (this.confirmation.signed_at_meta && this.confirmation.signed_at_meta.requested_data && this.confirmation.signed_at_meta.requested_data.unit_ledger_entries)
                        sharedUles = this.confirmation.signed_at_meta.requested_data.shared_unit_ledger_entries
                }

                let allUnitLedgerEntries = ules.concat(sharedUles);
                return allUnitLedgerEntries;
            },

            monthInputsByType() {
                let result = {};
                _.each(this.checkedMonths, (month, index) => {
                    let type = this.unitLedgerEntryTypes.find(item => item.id ===  this.rentType.id)
                    if (!type)
                        return
                    if (!result[type.id])
                        result[type.id] = {};
                    let uleRecord = JSON.parse(JSON.stringify(this.getUniteLedgerDataForDate(month)))

                    if (result[type.id][month])
                        return

                    result[type.id][month] = {
                        month,
                        program_id: uleRecord && uleRecord.program_application_unit_ledger_entry && uleRecord.program_application_unit_ledger_entry.household_application ? uleRecord.program_application_unit_ledger_entry.household_application.program_id : this.application.program_id,
                    }
                })
                _.each(this.entries, (entry, index) => {
                    let type = this.unitLedgerEntryTypes.find(item => item.id ===  entry.unit_ledger_entry_type_id)
                    if (!type)
                        return
                    if (!result[type.id])
                        result[type.id] = {};

                    if (result[type.id][entry.date])
                        return

                    result[type.id][entry.date] ={
                        month: entry.date,
                        program_id: entry.program_application_unit_ledger_entry && entry.program_application_unit_ledger_entry.household_application ? entry.program_application_unit_ledger_entry.household_application.program_id : this.application.program_id,
                    }
                })
                return result
            },

            ...mapState('App', {
                env: state => state.env,
            }),
            ...mapState('Application', {
                unitLedgerEntryTypes: state => state.assets && state.assets.unitLedgerEntryTypes ? state.assets.unitLedgerEntryTypes : [],
                application: state => state.application,
                unitLedgerEntries: state => state.application && state.application.unit_ledger_entries ? state.application.unit_ledger_entries : [],
                sharedUnitLedgerEntries: state => state.application && state.application.shared_unit_ledger_entries? state.application.shared_unit_ledger_entries : [],
                applicant: state => state.applicant,
                alternativeFundingPrograms: state => state.assets.alternativeFundingPrograms,
                programSettings: state => state.application.program.settings,
            }),
            ...mapState('Landlord', {
              confirmation: state => state.confirmation,
              otherApplicantUnitLedgerEntries: state => state.otherApplicantUnitLedgerEntries,
            }),
            ...mapState('App', {
              env: state => state.env,
            }),
        },
        watch: {
            application(newValue) {
                if(newValue) {
                    this.createEditValues();
                }
            },
            confirmation(newValue, oldValue) {
                if(!oldValue) {
                    this.createEditValues();
                }

                if(this.confirmation.approval === null) {
                    this.confirmation.approval = 'approved';
                }

                if(!newValue.edited_amount_meta || !newValue.edited_amount_meta.length) {
                    this.createEditValues();
                }
            },
            approval(newValue) {
                this.$store.commit('Landlord/setApproval', newValue);
            },
        },
        mounted() {
            if(this.confirmation) {
                if(!this.confirmation.edited_amount_meta || !this.confirmation.edited_amount_meta.length) {
                    this.createEditValues();
                }
            }

            if(this.confirmation && this.confirmation.approval === null) {
                this.confirmation.approval = 'approved';
            }
        },
        methods: {
            showCheckBox(month) {
                return this.isEditMode && (!this.alreadyHasAssistance(month) || !this.alreadyHasAssistance(month).household_application_id)
            },

            canEditMonth(month) {
                return this.isEditMode && this.checkedMonths.includes(month)
            },

            llZeroData(month) {
                return !this.monthInputs[month].due && !this.monthInputs[month].paid && !this.monthInputs[month].fees
            },

            getClassForMonth(month) {
                const data = this.alreadyHasAssistance(month)
                let paymentSubmitted = data && data.batch_vendor_payment_id,
                    checked = this.checkedMonths.includes(month)

                return {
                    // Turn green if the row has a payment
                    "light-green": paymentSubmitted,

                    // Turn red if the organization id for the row does not equal the selected vendor above.
                    "light-red": checked && !data && this.llZeroData(month)
                };
            },

            getValueForMonth(month, field) {
                let key = month
                if (typeof(month) == 'object') {
                    key = month.format(this.monthFormat)
                }
                if (this.monthInputs[key] !== undefined) {
                    let returnValue = this.monthInputs[key][field]
                        ? this.monthInputs[key][field]
                        : 0;
                    return returnValue;
                }
                return 0;
            },

            onMonthCheckedChange(month, $event) {
                if ($event.target.checked) {

                    // Check to see if the program setting for max months is enabled, and make
                    // sure the limit for maximum months is not being exceeded
                    let monthsAllowedCountIndependent = this.rentType.pivot.max_months_allowed;
                    let monthsAllowedType = this.programSettings['months-allowed-type'];
                    let monthAllowedCount = this.programSettings['months-allowed-amount'];
                    let monthsAllowedPrograms = this.programSettings['months-allowed-program-scope'];

                    if (monthsAllowedCountIndependent > 0)
                    {
                        let currentMonthCount = this.checkedMonths.length

                        if (currentMonthCount > monthsAllowedCountIndependent)
                        {
                            this.$nextTick(() => {
                                this.$toast.error(`The ${this.rentType.name} requested exceeds the allowable max number of months.`, {
                                    position: "top-right",
                                });
                                $(this.$refs['input_'+month]).prop('checked', false);
                            })
                            this.checkedMonths = this.checkedMonths.filter(item => item != month);
                            return false;
                        }
                    } else if(monthAllowedCount > 0) {
                        // Get number of checked months
                        let selectedMonths = [];

                        _.each(this.monthInputsByType, (data, typeId) => {
                            let type = this.unitLedgerEntryTypes.find(item => item.id == typeId)
                            if (type.pivot.type !== 2 && !type.pivot.max_months_allowed)
                            {
                                _.each(data, (monthInput, monthString) => {
                                    if(!monthsAllowedPrograms.includes(monthInput.program_id.toString())) {
                                        return;
                                    }
                                    if(monthsAllowedType === 'cumulative') {
                                        monthString = monthString + '_' + typeId;
                                    }
                                    if(!selectedMonths.includes(monthString)) {
                                        selectedMonths.push(monthString);
                                    }
                                });
                            }
                        })

                        if(selectedMonths.length > monthAllowedCount) {
                            this.$nextTick(() => {
                                this.$toast.error("Sorry, You already have requested max number of months available.", {
                                    position: "top-right",
                                });
                                $(this.$refs['input_'+month]).prop('checked', false);
                            })
                            this.checkedMonths = this.checkedMonths.filter(item => item != month);
                            return false;
                        }
                    }
                } else {
                    let tenantData = this.getRentMetaForDate(month)
                    if (tenantData.due || tenantData.paid || tenantData.fees)
                    {
                        this.$nextTick(() => {
                            this.monthInputs[month].due = 0
                            this.monthInputs[month].paid = 0
                            this.monthInputs[month].fees = 0
                            this.checkedMonths.push(month)
                        })
                    }
                }
                return true
            },
            
            getTotalRequestByMonth(month, type = 'landlord')
            {
                let result = 0
                let totalAdditionalFund = 0;
                let alternativeFundingProgram = []
                if (type == 'landlord')
                {
                    alternativeFundingProgram = this.monthInputs[month].alternative_funding_programs ? this.monthInputs[month].alternative_funding_programs : []
                } else {
                    const alternativeFundingProgramRecord = JSON.parse(JSON.stringify(this.getUniteLedgerDataForDate(month)));
                    alternativeFundingProgram = alternativeFundingProgramRecord.alternative_funding_programs ? alternativeFundingProgramRecord.alternative_funding_programs : [];
                }

                if (alternativeFundingProgram.length) {

                    totalAdditionalFund = alternativeFundingProgram.reduce((sum, item) => sum + parseFloat(item.pivot.amount), 0)
                }
                if (type == 'landlord')
                {
                    result = this.monthInputs[month].due + this.monthInputs[month].fees -this. monthInputs[month].paid
                } else {
                    let tenantData = this.getTenantMetaForDate(month)
                    result = tenantData.due + tenantData.fees - tenantData.paid
                }
                return result - totalAdditionalFund
            },
            getAlernativeFundProgramName(id) {
                const p = this.alternativeFundingPrograms.find(item => item.id == id);
                return p ? p.name : 'N/A';
            },
            addAssistance(programs) {
                if (this.isLocked)
                    return false
                programs.push({
                    isNew: true,
                    pivot: {
                        alternative_funding_program_id: null,
                        amount: 0,
                    }
                })
            },
            alreadyHasAssistance(month) {
                if(this.getRentMetaForDate(month).batch_vendor_payment_id) {
                    return this.getRentMetaForDate(month);
                }
                let existing = null;
                _.each(this.otherApplicantUnitLedgerEntries, entry => {
                    let dueDate = month + '-01';
                    if(entry.due_date == dueDate && entry.unit_ledger_entry_type_id == 1) {
                    existing = entry;
                    }
                })
                return existing;
            },
            checkMaxFees(month) {
                let maxFees = null;
                _.each(this.application.program.unit_ledger_entry_types, type => {
                    if(type.id == 1 && type.pivot && type.pivot.max_fee_amount) {
                        maxFees = type.pivot.max_fee_amount;
                    }
                })

                if(maxFees != null && this.monthInputs[month].fees > maxFees) {
                UIkit.modal.alert('The maximum fee amount for this assistance type is $' + maxFees + '. We have adjusted your fee amount accordingly. ' );
                this.monthInputs[month].fees = maxFees;
                }
            },
            getTenantMetaForDate(month) {
                const data = this.alreadyHasAssistance(month)
                let result = {
                    due: 0, fees: 0, paid: 0,
                };
                if (data && data.household_application_id)
                {
                    result = data
                } else {
                    result = this.getRentMetaForDate(month)
                }
                return result
            },
            getRentMetaForDate(date) {
                let requested_rent_meta = this.application.requested_rent_meta
                if (this.isLocked)
                {
                    if (this.confirmation.signed_at_meta && this.confirmation.signed_at_meta.requested_data && this.confirmation.signed_at_meta.requested_data.unit_ledger_entries)
                        requested_rent_meta = this.confirmation.signed_at_meta.requested_data.unit_ledger_entries.filter(item => item.unit_ledger_entry_type_id === 1)
                }
                for(var i in requested_rent_meta) {
                    let row = requested_rent_meta[i];
                    if(row.date == date) {
                        return {
                            date,
                            due: parseFloat(row.due),
                            paid: parseFloat(row.paid),
                            fees: parseFloat(row.fees),
                            other_funding: this.getOtherFundingTotal(row),
                            batch_vendor_payment_id: row.batch_vendor_payment_id,
                        };
                    }
                }
                return {
                    due: 0, fees: 0, paid: 0,
                };
            },
            getOtherFundingTotal(row) {
                let total = 0;
                _.each(row.alternative_funding_programs, program => {
                    total += parseFloat(program.pivot.amount);
                })
                return total;
            },
            getUniteLedgerDataForDate(date) {
                const row =  this.entries.find(item => item.date == date && item.unit_ledger_entry_type_id == 1)
                return row ? row : {
                    alternative_funding_programs: [],
                    pivot: {}
                }
            },
            
            createEditValues() {
                let start = moment(this.application.program.assistance_start).startOf('month');;
                if (this.isHomeless && this.programSettings['allow-only-futuer-month-rent-assistance'])
                {
                    start = moment(new Date()).startOf('month');
                }

                let end = moment(this.application.program.assistance_end);
                let added = parseInt(this.programSettings["ledger-entry-future-months"]);

                if (this.rentType)
                {
                    if (this.rentType.pivot.additional_months) {
                        added = parseInt(this.rentType.pivot.additional_months);
                        }
                    if(this.rentType.pivot.future_months_only) {
                        start = moment().add(1, 'month').startOf('month');
                    }
                }

                let endToShow = moment().clone().add(added, 'months');
                let months = [];
                if (start.isValid() && end.isValid())
                {
                    while(start.isBefore(end))
                    {
                        if(start.isAfter(endToShow)) break;
                        if(start.isAfter(end)) break;

                        months.push(start.clone());

                        start.add(1, 'month');
                    }
                }

                this.months = months;
                if(this.confirmation) {
                    _.each(this.months, month => {
                        let monthString = month.format('YYYY-MM');
                        let record = this.getRentMetaForDate(monthString)
                        let uleRecord = JSON.parse(JSON.stringify(this.getUniteLedgerDataForDate(monthString)))
                        let alternativeFundingProgramsValue = uleRecord.alternative_funding_programs ? uleRecord.alternative_funding_programs : [];
                        let editedAmountData = this.confirmation.edited_amount_meta
                        if (this.isLocked && this.confirmation.signed_at_meta && this.confirmation.signed_at_meta.requested_data && this.confirmation.signed_at_meta.requested_data.edited_amount_meta)
                        {
                            editedAmountData = this.confirmation.signed_at_meta.requested_data.edited_amount_meta 
                        }
                        if (_.size(editedAmountData))
                        {
                            record = editedAmountData[monthString];
                            
                            const alternativeFundingProgram = uleRecord.alternative_funding_programs ? uleRecord.alternative_funding_programs : [];
                            alternativeFundingProgramsValue = editedAmountData[monthString] && editedAmountData[monthString].alternative_funding_programs ? editedAmountData[monthString].alternative_funding_programs : []

                            if (alternativeFundingProgram.length > alternativeFundingProgramsValue.length)
                            {
                                for (var i = alternativeFundingProgramsValue.length; i < alternativeFundingProgram.length; i++)
                                {
                                    alternativeFundingProgramsValue.push(alternativeFundingProgram[i]);
                                }
                            }
                            if (alternativeFundingProgram.length < alternativeFundingProgramsValue.length)
                            {
                                for (var i = alternativeFundingProgram.length; i < alternativeFundingProgramsValue.length; i++)
                                {
                                    if (!alternativeFundingProgramsValue[i].isNew)
                                    {
                                        alternativeFundingProgramsValue.splice(i, 1)
                                    }
                                }
                            }
                        }

                        let assistanceData = this.alreadyHasAssistance(monthString)
                        let monthActive = uleRecord.id || assistanceData ? true: false

                        if(monthActive && !this.checkedMonths.includes(monthString)) {
                            this.checkedMonths.push(monthString);
                        }

                        let due = record ? parseFloat(record.due) : 0,
                            paid =  record ? parseFloat(record.paid) : 0,
                            fees = record ? parseFloat(record.fees) : 0,
                            own_ule = true

                        if (assistanceData && assistanceData.household_application_id && assistanceData.household_application_id != this.application.id)
                        {
                            due = uleRecord ? parseFloat(uleRecord.ll_due || uleRecord.due) : 0
                            paid =  uleRecord ? parseFloat(uleRecord.ll_paid || uleRecord.paid) : 0
                            fees = uleRecord ? parseFloat(uleRecord.ll_fees || uleRecord.fees) : 0
                            own_ule = false
                        }
                        
                        this.$set(this.monthInputs, monthString, {
                            date: month,
                            due,
                            paid,
                            fees,
                            alternative_funding_programs: alternativeFundingProgramsValue,
                            has_payment: uleRecord.batch_vendor_payment ? true : false,
                            own_ule
                        });
                    });
                }
            },
            async validateStep() {
                this.errors = {}
                if(this.approval === 'corrected') {
                    if(this.application.requested_rent_amount === this.updatedAmount) {
                        this.errors['corrected'] = { errors: ['You indicated the amount needs correction, but you made no changes.']}
                    }
                }


                if(_.size(this.errors) !== 0) {
                    return false;
                }

                let meta = {};
                _.each(this.monthInputs, (item, month) => {
                    if(item.own_ule === false)
                        return
                    meta[month] = {
                        date: item.date,
                        due: item.due,
                        paid: item.paid,
                        fees: item.fees,
                        alternative_funding_programs: item.alternative_funding_programs,
                    }
                })

                let url = `/api/landlord/${this.confirmation.id}/step-1`;
                try {
                    let params = {
                        approval: this.confirmation.approval,
                        values: meta,
                        updated_amount: this.updatedAmount,
                    }
                    if (this.confirmation.approval === 'declined') {
                        params['notes'] = this.confirmation.notes
                    }
                    let r = await axios.post(url, params);
                    this.$store.commit('Landlord/setConfirmation', r.data.confirmation);
                    return true;
                }catch(err) {
                    this.errors = err.response.data.errors;
                    return false;
                }
            }
        }
    }
</script>
